import { isNodeV2 } from '@vedalib/editor'

import { setSettings } from 'services/Store/Project/actions'
import { getBlock, getDeviceMode, mergeNodeStyle } from 'services/Store/Project/selectors'
import store from 'services/Store/store'

import { isGrid } from '../guards'

export const onShowGrid = (event?: KeyboardEvent) => {
  const state = store.getState().project
  const dispatch = store.dispatch
  const block = getBlock(state)
  const device = getDeviceMode(state)
  const root = block?.schema.nodes[block.schema.rootId]
  if (block && isNodeV2(root) && isGrid(mergeNodeStyle(root?.style || {}, device))) {
    event?.preventDefault()
    const current = state.state.editor.settings.showGrid
    dispatch(setSettings({ showGrid: !current }))
  }
}
